'use client';
import styled from 'styled-components';

export const StyledForm = styled.form`
  background: ${props => props.theme.colors.background.base};
  flex: 1;
  display: grid;
  grid-gap: ${props => props.theme.spacing(12)};
  justify-items: center;
  overflow: auto;
  margin-bottom: 74px; /* 74px for navigation bar */
`;

export const StyledFormWithImage = styled.form`
  background: ${props => props.theme.colors.background.base};
  width: 100vw;
  overflow: hidden;

  @media ${props => props.theme.laptop} {
    display: flex;
  }
`;

export const StyledFormWithIcon = styled(StyledForm)`
  width: 100vw;
  overflow: hidden;
`;
